/* eslint-disable import/prefer-default-export */
import headers from "app/requests/headers";

export const list = () => (
  fetch("/api/admin/admins", {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);
